import 'whatwg-fetch';
import React from 'react';
import CorePlugin, { utils } from '@annotation-studio/plugin-core';
import ViewerPlugin from '@annotation-studio/plugin-viewer';
import ResourceEditorPlugin from '@annotation-studio/plugin-resource-editor';
import {
  TaggingAnnotationsPlugin,
  TaggingPlugin,
} from '@annotation-studio/plugin-tagging';
import TranscriberPlugin from '@annotation-studio/plugin-transcriber';
import DraftsPlugin from '@annotation-studio/plugin-drafts';
import JsonPreviewPlugin from '@annotation-studio/plugin-json-preview';

const behaviours = resolveSharedStore => ({
  'annotation-studio-core': (image, attributes) =>
    CorePlugin(image, attributes).then(store => resolveSharedStore(store)),
  'annotation-studio-viewer': ViewerPlugin,
  'annotation-studio-resource-editor': ResourceEditorPlugin,
  'annotation-studio-tagging-annotations': TaggingAnnotationsPlugin,
  'annotation-studio-tagging': TaggingPlugin,
  'annotation-studio-drafts': DraftsPlugin,
  'annotation-studio-transcriber': TranscriberPlugin,
  'annotation-studio-json-preview': JsonPreviewPlugin,
});

const { resolve, promise: whenToRender } = utils.deferred();

function loadPlugin($el, name, config) {
  try {
    const register = behaviours(resolve);
    const behaviour = register[name];
    if (behaviour.length === 3) {
      whenToRender.then(store => behaviour($el, config, store));
    } else {
      behaviour($el, config);
    }
  } catch (e) {
    console.error('Behaviour does not exist: ' + name, e);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Small error-prone example of data behaviour factory.
  for (const $el of document.querySelectorAll('[data-behaviour]')) {
    loadPlugin(
      $el,
      $el.getAttribute('data-behaviour'),
      utils.getAttributes($el)
    );
  }
});

// Set up a global.
(g => {
  g.loadAnnotationStudioPlugin = g.loadAnnotationStudioPlugin
    ? g.loadAnnotationStudioPlugin
    : loadPlugin;
})(window || global);



// WEBPACK FOOTER //
// ../annotation-bundle/src/index.js